import React, { useContext, useEffect, useState } from "react";
import Link from "next/link";

import { GlobalContext } from "@/contexts/GlobalContext";
import { AuthContext } from "@/contexts/AuthContext";

import styles from "@/styles/components.module.scss";

const GenArtBar = () => {
    const { globalState: { vhInfo, cats } } = useContext(GlobalContext);
    const { authState: { isAdminAuth } } = useContext(AuthContext);

    const [partsLink, setPartsLink] = useState<string>("/car-parts");
    const [tcIndex, setTcIndex] = useState<number | null>(null);

    const [isVisible, setIsVisible] = useState<boolean>(false);

    useEffect(() => {
        if (vhInfo) {
            const make = vhInfo?.MAKE.toLowerCase().replace(/\s+|,\s/g, "-");
            const model = vhInfo?.MODEL1.toLowerCase().replace(/\s+|,\s/g, "-");

            setPartsLink(`/car-parts/${make}/${model.replace(/\//g, "-")}/${vhInfo.KCODE_B}`);
        }
    }, [vhInfo]);

    const handleExpandTopCat = (event: React.MouseEvent<HTMLLIElement>) => {
        const tcNr = event.currentTarget.getAttribute("data-tc") as string;

        if (tcIndex === parseInt(tcNr)) {
            return setTcIndex(null);
        }
        setTcIndex(parseInt(tcNr));
    };

    const handleToggleSideBar = () => {
        setIsVisible(!isVisible);
    };

    const resMenuButton = (
        <div className={styles["res-menu"]}>
            <span className={styles["res-slider"]} onClick={handleToggleSideBar}>
                <svg width="30" height="30">
                    <path d="M0,5 30,5" strokeWidth="2"/>
                    <path d="M0,14 30,14" strokeWidth="2"/>
                    <path d="M0,23 30,23" strokeWidth="2"/>
                </svg>
            </span>
        </div>
    );

    const resMenu = (
        <div className={styles["res-bar"]}>
            <ul className={styles["res-bar-list"]}>
                <li className={styles["res-link"]}>
                    <Link href="/">
                        Home
                    </Link>
                </li>

                <li className={styles["res-link"]}>
                    <Link href="/search">
                        Search Parts
                    </Link>
                </li>

                <li className={styles["res-link"]}>
                    <Link href="/cart">
                        Basket
                    </Link>
                </li>

                <li className={styles["res-link"]}>
                    <Link href="/blog">
                        Blog
                    </Link>
                </li>

                <li className={styles["res-link"]}>
                    <Link href="/about">
                        About
                    </Link>
                </li>

                <li className={styles["res-link"]}>
                    <Link href="/contact-us">
                        Contact Us
                    </Link>
                </li>

                {isAdminAuth && <li className={styles["res-link-dashboard"]}>
                    <Link href="/admin/dashboard">
                        Dashboard
                    </Link>
                </li>}
            </ul>
        </div>
    );

    const resMenuButtons = (
        <div className={styles["res-buttons"]}>
            <button 
                onClick={handleToggleSideBar} 
                className={styles["res-close-btn"]} 
            >&#10005;</button>
        </div>
    );

    const genLink = (genName: string, genNumber: number): string => {
        const gn = genName.toLowerCase().replace(/\s+|,\s/g, "-").replace(/\\|\//g, "");

        return `${gn}/${genNumber}`;
    };

    return (
        <React.Fragment>
            {resMenuButton}
            {vhInfo?.KCODE_B || isVisible ? <div className={styles[`genart-container${isVisible ? "--vis" : ""}`]}>
                <div className={styles["genart-bar"]}>
                    {isVisible && resMenuButtons}
                    {isVisible && resMenu}

                    <Link className={styles["parts-link"]} href={partsLink}>
                        Car Parts
                    </Link>

                    {vhInfo && vhInfo.KCODE_B && <ul className={styles["genart-links-list"]}>
                        {cats && cats.map(cat => (
                            <li 
                                key={cat.topcat_name} 
                                data-tc={cat.topcat_nr} 
                                onClick={handleExpandTopCat} 
                                className={styles[`genart-list-item${cat.topcat_nr === tcIndex ? "--active" : ""}`]}
                            >

                                <span className={styles["genart-card-title"]}>{cat.topcat_name}</span>
                                <div className={styles["genart-sub-links"]}>
                                    {cat.genarts.map(gen => (
                                        <a 
                                            key={gen.genart_nr} 
                                            href={`${partsLink}/${genLink(gen.genart_name, gen.genart_nr)}?qt=std`} 
                                        >{gen.genart_name}</a>
                                    ))}
                                </div>

                            </li>
                        ))}
                    </ul>}
                </div>
            </div> : null}
        </React.Fragment>
    );
};

export default GenArtBar;
